import React, { useState } from 'react';
import { formatText } from 'core/i18n';
import { AmountInput } from 'commonsComponents/amountInput';
import { recordEventError } from 'utilities/uTagging';
import PropTypes from 'prop-types';
import { COUNTRY_CODE_ES } from 'constants/multiLanguage';

const MAX_VALUE_DEPOSIT = 9999999;

export const DepositAmountInput = ({ changeDepositValue, handleOnFocus }) => {
    const defaultAmountData = {
        value: 0,
        errorState: false,
        errorMessage: '',
    };

    const [amountData, setAmountData] = useState(defaultAmountData);

    const inputCallback = value => {
        const isOverMax = value > MAX_VALUE_DEPOSIT;

        if (isOverMax) {
            const errorMessage = formatText('deposit-depositValueErrorLimit');
            setAmountData({
                ...defaultAmountData,
                errorState: true,
                errorMessage,
            });
            recordEventError(
                '/onboarding/deposito-configuracion',
                'error input importe',
                'error',
                'onboarding error deposito input importe',
                errorMessage
            );
            changeDepositValue(null);
            return;
        }

        if (!value || value < 0) {
            const errorMessage = formatText('deposit-depositValueErrorNull');

            setAmountData({
                ...defaultAmountData,
                errorState: true,
                errorMessage,
            });
            recordEventError(
                '/onboarding/deposito-configuracion',
                'error input importe',
                'error',
                'onboarding error deposito input importe',
                errorMessage
            );
            changeDepositValue(null);
            return;
        }

        setAmountData({
            ...defaultAmountData,
            value: value,
        });
        changeDepositValue(value);
    };

    return (
        <div className="row md-form-group">
            <div className="col-sm-6 amount-input-container">
                <AmountInput
                    amount={amountData.value}
                    callback={inputCallback}
                    error={amountData.errorState}
                    errorMsg={amountData.errorMessage}
                    label={formatText('deposit-depositValueTitle')}
                    language={COUNTRY_CODE_ES}
                    hideFocusZero={true}
                    showBlurZero={false}
                    removeDecimals={true}
                    fluid={true}
                    maxBackEndFractionLength={0}
                    inlineUnit={'€'}
                    maxIntegerLength={7}
                    placeholder={formatText('deposit-importPlaceHolder')}
                    min={0}
                    handleOnFocus={handleOnFocus}
                    forceNumericKeyboard
                />
            </div>
            {!amountData.errorState && (
                <div className="col-sm-7 input-info">
                    <span>{formatText('deposit-depositValueDescription')}</span>
                </div>
            )}
        </div>
    );
};

DepositAmountInput.propTypes = {
    changeDepositValue: PropTypes.func,
    handleOnFocus: PropTypes.func,
};
